module.exports = __webpack_public_path__ + "static/media/teamphoto_justin2.6a66158d.jpg";